

import { useNavigate } from "react-router-dom";

interface QuotationHeaderProps {
  quotationNumber: string;
  clientName?: string;
  eventType?: string;
  logoUrl?: string;
  businessName?: string;
}

export default function QuotationHeader({
  quotationNumber,
  clientName,
  eventType,
  logoUrl,
  businessName,
}: QuotationHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl border border-stone-200 shadow-sm overflow-hidden">
      <div className="px-6 py-4 bg-gradient-to-r from-stone-50 to-white border-b border-stone-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {logoUrl && (
              <img 
                src={logoUrl} 
                alt={businessName} 
                className="h-12 w-auto object-contain"
              />
            )}
            <div>
              <h1 className="text-2xl font-bold text-stone-800">{quotationNumber}</h1>
              <p className="text-stone-600 mt-1">{clientName} • {eventType}</p>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 rounded-lg border border-stone-200 text-stone-700 hover:bg-stone-100 transition-colors"
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
